import PickRec from './src/PickRec';

export default PickRec;
